<template>
  <sidebar-overlay class="participantList">
    <h2 class="sidebarTitle">Waiting Room</h2>
    <ul>
      <li class="sentry-masked-text" v-for="user in inWaitingRoom" :key="user.id">
        <span class="name"> {{ user.firstName }} {{ user.lastName }} </span>
        <button class="reject" @click="reject(user.id)">Reject</button>
        <button class="admit" @click="admit(user.id)">Admit</button>
      </li>
    </ul>
    <div class="actions">
      <button class="admitAll btn btn-border" @click="admitAll">Admit all</button>
    </div>
  </sidebar-overlay>
</template>

<script setup>
import { watch, computed, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import { useSidebarStore } from '@/store/pinia/sidebar';
import { useUsersStore } from '@/store/pinia/users';
import { useMessagesStore } from '@/store/pinia/messages';
import SidebarOverlay from '@/components/SidebarOverlay';

const $meetingmanager = getCurrentInstance().appContext.config.globalProperties.$meetingmanager;
const usersStore = useUsersStore();
const sidebarStore = useSidebarStore();
const messagesStore = useMessagesStore();
const { inWaitingRoom } = storeToRefs(usersStore);

const hasWaiting = computed(() => inWaitingRoom.value.length > 0);

function admit(id) {
  $meetingmanager.approveJoiningRequests({ userIds: [id] });
  messagesStore.removeAlert({ filter: (t) => t.messageName !== 'userWaiting' || t.userId !== id });
}

function admitAll() {
  const userIds = inWaitingRoom.value.map((user) => user.id);
  $meetingmanager.approveJoiningRequests({ userIds });
  messagesStore.removeAlert({ messageName: 'userWaiting' });
  // ßsidebarStore.closeParticipantList();
}

function reject(id) {
  $meetingmanager.rejectJoiningRequest({ userId: id });
  messagesStore.removeAlert({ filter: (t) => t.messageName !== 'userWaiting' || t.userId !== id });
}

// automatically close once there is nobody left
watch(hasWaiting, (nv) => {
  console.log('hasWaiting', nv);
  if (!nv) {
    sidebarStore.closeParticipantList();
  }
});
</script>

<style lang="scss" scoped>
.participantList {
  padding-top: rem(78px);
  padding-bottom: 0;
}

ul,
h2 {
  padding: 0 rem($sidebar-left-pad);
}

ul,
.actions {
  margin-top: rem(28px);
}

li {
  display: flex;
  gap: 1em;
}

li + li {
  margin-top: 0.5em;
}

.name {
  margin-right: auto;
  flex: 1 1 auto;
}

ul button {
  flex: 0 0 auto;
}

.reject {
  color: var(--c__warn);

  @include triggered {
    color: var(--c__warn-loud);
  }
}

.admit {
  color: var(--c__accent);

  @include triggered {
    color: var(--c__accent-alt);
  }
}

ul {
  margin-bottom: auto;
}

.actions {
  margin: 2em rem($sidebar-left-pad) rem($log-height - 50px) rem($sidebar-left-pad);
}

.admitAll {
  border-width: 3px;
  height: rem(50px);
  display: block;
  width: 100%;
}
</style>
